import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

import { GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY } from './hooks/useDependents.query';

const useRemoveDependentQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    // TODO: absent url
    (id: string) => api.put(PATHS.DEACTIVATE_DEPENDENT(id)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY] });
      },
    }
  );
  return {
    removeDependent: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useRemoveDependentQuery;
